import { render, staticRenderFns } from "./ShipmentRequestList.vue?vue&type=template&id=01da004e&scoped=true"
import script from "./ShipmentRequestList.vue?vue&type=script&lang=js"
export * from "./ShipmentRequestList.vue?vue&type=script&lang=js"
import style0 from "./ShipmentRequestList.vue?vue&type=style&index=0&id=01da004e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da004e",
  null
  
)

export default component.exports